import { render, staticRenderFns } from "./PorProfissional.vue?vue&type=template&id=da99c80e"
import script from "./PorProfissional.vue?vue&type=script&lang=js"
export * from "./PorProfissional.vue?vue&type=script&lang=js"
import style0 from "./PorProfissional.vue?vue&type=style&index=0&id=da99c80e&prod&lang=css"
import style1 from "./PorProfissional.vue?vue&type=style&index=1&id=da99c80e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports